<div class="cf-document-info">
    <div class="grid-title">{{ 'cf-document.grid.document-info-section' | translate }}</div>
    <div class="info-buttons">
        <kendo-buttongroup class="margin-bottom-10">
            <button
                class="margin-right-10"
                kendoButton
                type="button"
                themeColor="info"
                title="{{ 'cf-document.button.blockchain' | translate }}"
                (click)="openBlockchainExplorer()">
                <kendo-svg-icon [icon]="trackChangesEnableIcon"></kendo-svg-icon>
                {{ 'cf-document.button.blockchain' | translate }}
            </button>
            <button
                (click)="onFileDownload()"
                class="margin-right-10"
                title="{{ 'cf-document.button.download-pdf' | translate }}"
                type="button"
                kendoButton>
                <kendo-svg-icon [icon]="filePdfIcon"></kendo-svg-icon>
                {{ 'cf-document.button.download-pdf' | translate }}
            </button>
            <button
                *ngIf="document.destinationLocationUrl"
                kendoButton
                type="button"
                title="{{ 'cf-document.button.map' | translate }}"
                (click)="openGoogleMaps(document.destinationLocationUrl)">
                <kendo-svg-icon [icon]="globeIcon"></kendo-svg-icon>
                {{ 'cf-document.button.map' | translate }}
            </button>
        </kendo-buttongroup>
    </div>

    <div class="item">
        <div class="label">{{ 'cf-document.label.id' | translate }}:</div>
        <div class="content">{{ document.cloudFlowId }}</div>
    </div>

    <div class="item">
        <div class="label">{{ 'cf-document.label.externalId' | translate }}:</div>
        <div class="content">{{ document.externalId }}</div>
    </div>

    <div class="item">
        <div class="label">{{ 'cf-document.label.documentType' | translate }}:</div>
        <div class="content">{{ document.documentType }}</div>
    </div>

    <div class="item">
        <div class="label">{{ 'cf-document.label.documentNumber' | translate }}:</div>
        <div class="content">{{ document.documentNumber }}</div>
    </div>

    <div class="item">
        <div class="label">{{ 'cf-document.label.companyId' | translate }}:</div>
        <div class="content">{{ document.companyId }}</div>
    </div>

    <div class="item">
        <div class="label">{{ 'cf-document.label.documentState' | translate }}:</div>
        <div class="content">{{ document.documentState }}</div>
    </div>

    <div class="item">
        <div class="label">{{ 'cf-document.label.publishDate' | translate }}:</div>
        <div class="content">{{ document.publishDate | date: 'dd-MM-yyyy HH:mm:ss' }}</div>
    </div>

    <div class="item">
        <div class="label">{{ 'cf-document.label.publisherEmail' | translate }}:</div>
        <div class="content">{{ document.publisherEmail }}</div>
    </div>

    <div class="item" *ngIf="!authenticationService.isQrSignatureRoute">
        <div class="label">{{ 'cf-document.label.documentHash' | translate }}:</div>
        <div class="content" title="{{ document.documentHash }}">{{ document.documentHash }}</div>
    </div>

    <div class="grid-title margin-top-20">{{ 'cf-document.grid.document-sections' | translate }}</div>
    <div class="item" *ngFor="let section of document.sections">
        <div class="label">{{ section.sectionName }}:</div>
        <div class="content">
            <span class="badge {{ getStatusColor(section.signatureState) }}">
                {{ section.signatureState }}
            </span>
        </div>
    </div>
</div>
